import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from '@mui/material'

import { Icon, iconNames } from '../../icons'
import { Button } from '../Button'
import { DialogFormula } from '../../dialogs'
import './style.scss'

export const ButtonFormula = (props) => {
  const { forwardedRef, parameters, onValidate, tooltip } = props
  const [openDialog, setOpenDialog] = useState(false)

  const onClick = () => {
    setOpenDialog(!openDialog)
  }

  return (
    <>
      <Tooltip title={tooltip} ref={forwardedRef}>
        <Button
          icon={<Icon name={iconNames.FUNCTION} size={18} />}
          className="buttonFormula"
          onClick={onClick}
          {...props}
        />
      </Tooltip>
      {openDialog && (
        <DialogFormula
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          parameters={parameters}
          onValidate={onValidate}
        />
      )}
    </>
  )
}

ButtonFormula.displayName = 'ButtonFormula'

ButtonFormula.propTypes = {
  forwardedRef: PropTypes.any,
  parameters: PropTypes.arrayOf(PropTypes.object),
  tooltip: PropTypes.string,
  onValidate: PropTypes.func.isRequired
}

ButtonFormula.defaultProps = {
  forwardedRef: null,
  parameters: [],
  tooltip: '',
  onValidate: () => {}
}
